<!--
 * @Description: 
 * @Author: jml
 * @Date: 2021-01-05 11:04:55
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-05 15:07:39
-->
<script>
import { projectPersonnelManagement } from '@/api/ajax';
import RevokeList from './revoke-list';
export default {
  name: 'taskRevoke',
  data() {
    return {
      revokeCount: 0
    };
  },
  props: {
    search: Object
  },
  render(h) {
    const handler = () => {
      this.revokeCount = 0;
      this.$xrkDialog({
        title: '任务撤回',
        width: '1150px',
        showConfirm: false,
        showCancel: false,
        $slots: {
          default: h(RevokeList, {
            props: {
              startDt: this.search.taskDt,
              endDt: this.search.taskEndDt
            }
          })
        }
      });
    };
    return (
      <el-button style="position:relative;" type="primary" onClick={handler}>
        任务撤回
        {this.revokeCount > 0 && (
          <span style="position:absolute;right:-4px;top:-4px;width:10px;height:10px;background-color:red;border-radius: 10px;"></span>
        )}
      </el-button>
    );
  },
  created() {
    projectPersonnelManagement
      .getNewestUserTaskRevoke({
        projectType: this.$store.state.homeProject.projectType,
        projectId: this.$store.state.homeProject.id,
        id: localStorage.getItem('revokeId') || ''
      })
      .then(({ data: { data } }) => {
        this.revokeCount = data;
      });
  }
};
</script>

<style></style>
